import React, { useEffect, useState } from 'react';

import { FaRegCalendarDays, FaSquareArrowUpRight } from 'react-icons/fa6';
import web from '../assets/images/web.gif';
import Navbar from '../components/body_nav';
import project1 from '../assets/images/project1.webp';
import project2 from '../assets/images/project2.webp';
import project3 from '../assets/images/project3.webp';
import project4 from '../assets/images/project4.webp';
import project5 from '../assets/images/project5.webp';
import pro from '../assets/images/Projects/Pro.png';
import { toast } from 'react-toastify';
import axios from 'axios';

function Body({ notifyError }) {
  const [projects, setProjects] = useState([]);

  const fetchProjects = async () => {
    try {
      const response = await axios.get(
        'https://port-folio-back-end.vercel.app/api/admin/getAllProjects'
      );
      setProjects(response.data);
    } catch (error) {
      // notifyError("Failed to fetch projects");
      console.error(error);
    }
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  const project_data = [
    {
      image: project1,
      title: 'Job Portal',
      category: 'Job Portal | Website',
      url: '',
    },
    {
      image: project2,
      title: 'Atai Construction',
      category: 'Buisness Portfolio | Website',
      url: '',
    },
    {
      image: project3,
      title: 'Alphavoir',
      category: 'E-Commerce | Website',
      url: 'https://alphavoir.com',
    },
    {
      image: project4,
      title: 'Kingvape',
      category: 'Buisness Portfolio | Website',
      url: '',
    },
    {
      image: project5,
      title: 'WelcomeFuels',
      category: 'Buisness Portfolio | Website',
      url: 'https://welcomefuels.com',
    },
  ];

  const handleprojecturl = (link) => {
    if (!link.startsWith('http://') && !link.startsWith('https://')) {
      link = 'https://' + link;
    }
    window.location.href = link;
  };
  const handleAccountUrl = (link) => {
    if (!link.startsWith('http://') && !link.startsWith('https://')) {
      link = 'https://' + link;
    }
    window.location.href = link;
  };
  const handleErrorClick = () => {
    notifyError('No live URL found!');
  };

  return (
    <>
      <Navbar title={'Projects'} icon={<FaRegCalendarDays />} />
      <div class="pt-3 pb-2 w-[95%]">
        <p class="text-lightgrey">
          Explore a collection of my work showcasing diverse projects across web
          development, data-driven applications, and more. Each project
          demonstrates my skills in various technologies and my commitment to
          delivering quality solutions. Dive in to see how I approach challenges
          and create impactful results. Click on each project to learn more and
          visit the live version.
        </p>
      </div>
      {/* //w-[43vw] md:w-[31%] */}
      <div className="flex  justify-center gap-[2.5%] flex-wrap overflow-y-auto  mt-2">
        {projects.map((item, index) => (
          <div className="flex   mx-auto items-center w-[280px] h-[280px] flex-col gap-1 justify-center py-2 rounded-md ">
            <div className="relative rounded-2xl group">
              <div className="w-[220px] h-[220px]  flex items-center justify-center ">
                <img
                  // src={pro}
                  src={item.image}
                  alt="skill"
                  height="100%"
                  weight="100%"
                  class="rounded-xl  transition duration-300 transform hover:scale-105"
                />
              </div>
              <button
                onClick={
                  item?.liveLink
                    ? handleprojecturl.bind(this, item?.liveLink)
                    : handleAccountUrl.bind(this, item?.githubLink)
                }
                class="absolute top-1 right-1 flex gap-1 items-center text-black p-2 rounded-3xl hover:bg-primary hover:text-seagreen md:hidden transition duration-700 group-hover:md:flex"
              >
                Visit
                <FaSquareArrowUpRight />
              </button>
            </div>
            <h2 className="text-lightgrey text-xl font-semibold">
              {item.title}
            </h2>
          </div>
        ))}
      </div>
    </>
  );
}

export default Body;
